import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { Level } from "@modules/levels/types";
import { LevelFormValues } from "@modules/levels/validations";
import { editLevelService } from "./service";
import { UseEditLevelMutationOptions } from "./types";

export function useEditLevelMutation(
  options?: UseEditLevelMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<Level, ApiError, { id: string; data: LevelFormValues }>({
    mutationFn: ({ id, data }) => editLevelService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("level_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
